import { render, staticRenderFns } from "./POSTopSection.vue?vue&type=template&id=6105b985&scoped=true&"
import script from "./POSTopSection.vue?vue&type=script&lang=js&"
export * from "./POSTopSection.vue?vue&type=script&lang=js&"
import style0 from "./POSTopSection.vue?vue&type=style&index=0&id=6105b985&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6105b985",
  null
  
)

export default component.exports